<template>
  <PageContent>
    <div class="bismarck-brief-subtitle">Brief</div>
    <h2 class="bismarck-brief-tagline">
      Navigation-grade analysis of key institutions, industries, and live
      players, delivered to your inbox every week.
    </h2>
    <div class="bismarck-brief-cover">
      <img
        src="/images/JFK_Chep_Morrison_Oval_Office_1961_Reading_Color.jpeg"
      />
    </div>
    <h4 class="bismarck-brief-prelude-upper">
      Bismarck Brief sends out a new report every week with analysis of an
      important institution, industry, or live player, to equip subscribers with
      navigation-grade information about the state of the world.
    </h4>
    <p class="bismarck-brief-prelude-lower">
      Whether examining the Chinese space industry, Europe&rsquo;s new
      continental border agency, or the long-term strategy of the Blackstone
      Group, subscribers can expect to gain new insights into the individuals
      and organizations that are most responsible for shaping the power and
      institutional landscape of the world. Rather than novelty or
      “newsworthiness,” topic selection is informed by the Bismarck team&rsquo;s
      collective years of experience in analyzing the fundamentals that drive
      world affairs.
    </p>
    <div class="bismarck-brief-buttons">
      <a
        class="bismarck-brief-subscribe-button"
        href="https://brief.bismarckanalysis.com/subscribe"
        target="_blank"
        >Subscribe</a
      >
    </div>
    <section class="bismarck-brief-letter">
      <p>
        In 2017, I founded Bismarck Analysis to help companies, governments,
        philanthropists, and investors better understand the world in which we
        all live and operate. Understanding the world is a prerequisite for
        pursuing the right strategy to accomplish your goals. The lens through
        which I view the world,
        <a href="https://samoburja.com/gft/">Great Founder Theory</a>, proposes
        that the world is a landscape of institutions, both functional and not,
        robotically pursuing objectives set by their founders. Live players
        navigate this landscape and may found institutions, or use other
        methods, to pursue their unique goals, affecting the world around them.
        To understand these institutions and players is to understand the world
        as best as we can. Since confidentiality is often key to our work,
        Bismarck has released only a handpicked selection of our analytical
        products to the public. With Bismarck Brief, we offer a look into our
        ongoing exploration of the global power landscape.
      </p>
      <div class="bismarck-brief-buttons">
        <a
          class="bismarck-brief-subscribe-button"
          href="https://www.bismarckanalysis.com/The_Long_March_Into_Space.pdf"
          target="_blank"
          >Download Sample</a
        >
      </div>
      <p>
        The case study model forms the core of our research method, since every
        subject of analysis is necessarily far too unique to be explained in
        purely statistical terms, or only by reference to broader trends. Each
        Bismarck Brief is thus an in-depth case study examining the origins,
        ideologies, functions, competitors, future prospects, and more, of the
        chosen subject, with proposed implications for wider society. Through an
        analysis of the most important necessary facts, the Bismarck Brief
        provides strategically useful conclusions and gives you, the reader, a
        wider, deeper, and more timely understanding of the global strategic
        landscape. I invite you to
        <a href="https://brief.bismarckanalysis.com/subscribe">subscribe</a>
        today and join us on this ongoing exploration.
      </p>
      <img
        class="bismarck-brief-signature"
        src="/images/samo-signature-white.png"
      />

      <p class="samo-signoff">
        Samo Burja
      </p>
      <p class="samo-signoff">
        President and CEO
      </p>
      <p class="samo-signoff">
        Bismarck Analysis
      </p>
    </section>
  </PageContent>
</template>

<script>
import PageContent from "./PageContent.vue";
export default {
  name: "Analysis",
  components: { PageContent },
  beforeCreate() {
    document.title = "Bismarck Analysis | Brief";
  },
};
</script>

<style scoped>
.bismarck-brief-buttons,
.bismarck-brief-prelude-upper,
.bismarck-brief-prelude-lower,
.bismarck-brief-letter {
  max-width: 760px;
  margin: auto;
}

.bismarck-brief-subtitle {
  text-transform: uppercase;
  font-family: "Big caslon", "Libre Caslon Text", "Times New Roman", Times,
    serif;
  color: #fff;
  font-size: 14pt;
  font-weight: 400;
  margin-top: -46px;
  font-kerning: none;
  letter-spacing: 4px;
  width: 230px;
  text-align: center;
}

/* dynamic for screens less than 768px */
@media screen and (max-width: 699px) {
  .bismarck-brief-subtitle {
    margin-top: -170px; /* = -120 - (BRIEF_HEADER_SPACE_MID := 50) */
  }
  .bismarck-brief-tagline {
    padding-top: 50px; /* = (BRIEF_HEADER_SPACE_MID := 50) */
  }
}
@media screen and (max-width: 390px) {
  .bismarck-brief-subtitle {
    margin-top: -254px
      /* = -2M - (BRIEF_HEADER_SPACE_SMALL := 58), where M = 93 as determined by experiment */;
  }
  .bismarck-brief-tagline {
    padding-top: 151px; /* = M + (BRIEF_HEADER_SPACE_SMALL := 58), where M = 93 as determined by experiment */
  }
}

.bismarck-brief-letter {
  text-align: left;
}
.bismarck-brief-signature {
  width: 300px;
  margin-top: 32px;
}

.bismarck-brief-buttons {
  display: flex;
  justify-content: center;
  margin-top: 32px;
  margin-bottom: 32px;
}

p {
  margin-bottom: 16px;
}

a.bismarck-brief-subscribe-button {
  display: inline-block;
  padding: 10px 20px;
  background-color: rgba(255, 255, 255, 1);
  color: black;
  text-decoration: none;
  border-radius: 4px;
  line-height: 20px;
  text-align: center;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 1px;

  /* padding: 15px 30px;
  font-size: 20px; */
}
a.bismarck-brief-subscribe-button:hover {
  background-color: rgba(255, 255, 255, 0.8);
}

p.samo-signoff {
  margin-top: 0px;
  margin-bottom: 0px;
}
h2 {
  margin-top: 3em;
  line-height: 135%;
  margin-bottom: 2em;
  padding-right: 5%;
}
.bismarck-brief-prelude-upper {
  margin-top: 10px;
  margin-bottom: 10px;
  padding-top: 32px;
  padding-bottom: 16px;
}

.bismarck-brief-cover img {
  filter: grayscale(100%);
  height: 512px;
  width: 100%;
  object-fit: cover;
}
.bismarck-brief-cover {
}
</style>
